import { types } from "mobx-state-tree";

import { BaseQueryModel } from "@/shared/model/base-query-model.js";

export const BaseSourceModel = BaseQueryModel.named("BaseSourceModel").props({
  iframe: types.model({
    url: types.maybeNull(types.string),
  }),
});
